angular
    .module('annexaApp')
    .component('annexaBoxObjectReg',{
        templateUrl: function($element, $attrs) {
            return (($attrs.isEdit == 'false' || $attrs.isEditModal == 'false') ?
                './components/reg/annexa-box-object-reg/annexa-box-object-reg.html' :
                './components/reg/annexa-box-object-reg/annexa-box-object-reg-edit.html')
        },

        controller: ['RegFactory', '$filter', '$rootScope', 'ErrorFactory', '$state', '$scope', '$compile', 'RestService', 'HelperService', 'AnnexaPermissionsFactory', 'GlobalDataFactory', 'Language', 'AnnexaFormlyFactory', 'CommonService', 'DialogsFactory', 'ThirdFactory', 'AnnexaBoxDossierFactory', 'NotificationFactory', 'TramNewFactory', 'AnnexaModalFactory', 'TerritoryFactory', 'DccumentsFactory', 'AuditFactory', 'RegModals', '$stateParams', '$http',
        	function (RegFactory, $filter, $rootScope, ErrorFactory, $state, $scope, $compile, RestService, HelperService, AnnexaPermissionsFactory, GlobalDataFactory, Language, AnnexaFormlyFactory, CommonService, DialogsFactory, ThirdFactory, AnnexaBoxDossierFactory, NotificationFactory, TramNewFactory, AnnexaModalFactory, TerritoryFactory, DccumentsFactory, AuditFactory, RegModals, $stateParams, $http) {

            //region General

            var vm = this;
			vm.requiredResponsible = false; 
            vm.languageColumn = Language.getActiveColumn();
            vm.loggedUser = $rootScope.LoggedUser;

            //endregion

            //region Form

            var hideUniqueWindow = function($viewValue, $modelValue, scope) {
                return !scope.model.uniqueWindow_1;
            }

            var showIfUniqueWindow = function(model) {
                return model[this.id] != null || model.uniqueWindow;
            }

            var showIfRegisterEntryOffice = function(model) {
                return $rootScope.app.configuration.multiple_register_office && $rootScope.app.configuration.multiple_register_office.active;
            }

            var getColClass = function(id) {
                if(vm.isModal) {
                    switch (id) {
                        case 'registerEntryChannel':
                        case 'documentDate':
                        case 'registerEntryOffice':
                            if ($rootScope.app.configuration.multiple_register_office && $rootScope.app.configuration.multiple_register_office.active && GlobalDataFactory.registerEntryOffices.length > 1) {
                                return 'col-sm-4'
                            } else {
                                return 'col-sm-6'
                            }
                            break;
                        case 'entryDocumentType':
                        case 'entryClassification':
                            return 'col-sm-6'
                    }
                }

                return 'col-sm-12';
            }

            // Aqui nos creamos el formulario para un nuevo registro de entrada.
            if(vm.registerEntry && vm.registerEntry.presentationDate){
                vm.registerEntry.presentationTime = vm.registerEntry.presentationDate;
            }
            if (vm.registerEntry && vm.registerEntry.effectiveDate) {
            	vm.registerEntry.effectiveTime = vm.registerEntry.effectiveDate;
            }
            
            var requiredArchiveClassification = false;
            var requiredTramClassification = false;
            var showTramClassification = false;
            if(vm.entryType == 'INPUT') {
            	if($rootScope.app.configuration.required_archive_classification_register_entry) requiredArchiveClassification = $rootScope.app.configuration.required_archive_classification_register_entry.value;
            	if($rootScope.app.configuration.tram_classification_register_entry) {
            		requiredTramClassification = $rootScope.app.configuration.tram_classification_register_entry.required;
            		showTramClassification = $rootScope.app.configuration.tram_classification_register_entry.show;
            	}
            }
            
            if(vm.entryType == 'OUTPUT') {
            	if($rootScope.app.configuration.required_archive_classification_register_output) requiredArchiveClassification = $rootScope.app.configuration.required_archive_classification_register_output.value
            	if($rootScope.app.configuration.tram_classification_register_output) {
            		requiredTramClassification = $rootScope.app.configuration.tram_classification_register_output.required;
            		showTramClassification = $rootScope.app.configuration.tram_classification_register_output.show;
            	}
            }
            
            vm.archiveClassifications = undefined;
            if(vm.isEdit) {
            	vm.archiveClassifications = GlobalDataFactory.archiveClassifications;
            } else {
            	vm.archiveClassifications = CommonService.getTreeData(GlobalDataFactory.archiveClassifications, Language.getActiveColumn());
            }
            
            var printQdC = function(value) {
                var qdc = '';
                var id  = undefined;

                var getName = function(item, label) {

                    if(label) {
                        label = ' / ' + label;
                    }

                    if(item){
                    	label = ((item[Language.getActiveColumn()])?item[Language.getActiveColumn()]:((item.id)?item.id:'undefined')) + label;
    	                if(item.parent) {
    	                	label = getName(item.parent, label);
    	                }
                    }
                    return label;
                }
                if(value && value.model && value.model.$selected && value.model.$selected.id) {
                    id = value.model.$selected.id;
                } else if(value && value.id) {
                	id = value.id;
                }
                
                if(id) {
                	var selectedQdc = $linq(GlobalDataFactory.archiveClassifications).singleOrDefault(undefined, "x => x.id == " + id);

                    if(selectedQdc) {
                        qdc = getName(selectedQdc, qdc);
                    }
                }

                return qdc;
            }
            
            var printUniqueWindow = function(value) {
            	if(value) {
                    return $filter('translate')('global.literals.yes');
                } else {
                    return $filter('translate')('global.literals.no');
                }
            }
            
            var uniqueWindowField = {};
            if(vm.isEdit) {
            	uniqueWindowField = { type: 'field', id: 'uniqueWindow', fieldType: 'radio_checkbox', data: [{value: 1, label: $filter('translate')('global.literals.uniqueWindow')}], colClass: 'col-sm-12', required: false, label: $filter('translate')('global.literals.uniqueWindow'), printFunction: printUniqueWindow }
            } else {
            	uniqueWindowField = { type: 'field', id: 'uniqueWindow', fieldType: 'radio_checkbox', data: [{value: 1, label: $filter('translate')('global.literals.uniqueWindow')}], colClass: 'col-sm-12', required: false, label: '' }
            }
            
            vm.newRegisterEntryInputFormFields = [
            	
                { type: 'predefined', predefined: 'profile', id: 'profile', data: 'loggedUser', origin: 'RegisterEntryInput', colClass: 'col-sm-12', required: true},
                { type: 'predefined', predefined: 'section', id: 'section', data: 'loggedUser', colClass: 'col-sm-12', required: true}, //aquest camp provoca al debugger del chrome --> RangeError: Maximum call stack size exceeded
                { type: 'field', id: 'presentationDate', fieldType: 'date', colClass: 'col-sm-6', required: true, label: 'global.literals.presentationDate', defaultValue: new Date(), remove: vm.entryType == 'OUTPUT', hideExpression: function(){return (vm.entryType == 'OUTPUT');}, showIf: function(){return (vm.entryType != 'OUTPUT');}, isReadOnly:false},
                { type: 'field', id: 'presentationTime', fieldType: 'time', colClass: 'col-sm-6', required: true, label: 'global.literals.time', defaultValue: new Date(), remove: vm.entryType == 'OUTPUT', hideExpression: function(){return (vm.entryType == 'OUTPUT');}, showIf: function(){return (vm.entryType != 'OUTPUT');}, isReadOnly:false },
                { type: 'field', id: 'archiveClassification', fieldType: 'select-tree', colClass: 'col-sm-12', data: vm.archiveClassifications, required: requiredArchiveClassification, label: 'global.literals.classificationBox', model: {}, printFunction: printQdC },
                { type: 'field', id: 'tramClassification', fieldType: 'select', data: GlobalDataFactory.tramClassifications, colClass: 'col-sm-12', required: requiredTramClassification, label: 'global.literals.tramClassification', removeOnEset: false, defaultValue: vm.tramClassification ? vm.tramClassification : undefined, hideExpression: function(){return (!showTramClassification);}, showIf: function(){return (showTramClassification);} },
                { type: 'field', id: 'registerEntryChannel', fieldType: 'select', data: vm.entryType == 'INPUT' ? GlobalDataFactory.registerEntryChannelsInput : GlobalDataFactory.registerEntryChannelsOutput, colClass: getColClass('registerEntryChannel'), required: true, label: 'global.literals.channel', defaultValue: vm.entryType == 'INPUT' ? GlobalDataFactory.registerEntryChannelsInput[0] : GlobalDataFactory.registerEntryChannelsOutput[0],
                	controller: ['$scope', function($scope) {
                		$scope.$on('registerEntryOfficeChanged', function (event, args) {
                			$scope.model.registerEntryChannel = args.item;
                		});
                	}]
                },
                { type: 'field', id: 'documentDate', fieldType: 'date', colClass: getColClass('documentDate'), required: false, label: 'global.literals.documentDate' },
                { type: 'field', id: 'entryDocumentType', fieldType: 'select', data: vm.entryType == 'INPUT' ? GlobalDataFactory.registerEntryDocumentTypesInput : GlobalDataFactory.registerEntryDocumentTypesOutput, colClass: getColClass('entryDocumentType'), required: false, label: 'global.literals.regType', removeOnEset: false, editPermissions: !vm.diligenceId ? vm.newPerm : undefined },
                { type: 'field', id: 'entryClassification', fieldType: 'select', data: vm.entryType == 'INPUT' ? GlobalDataFactory.registerEntryClassificationsInput : GlobalDataFactory.registerEntryClassificationsOutput, colClass: getColClass('entryClassification'), required: false, label: 'global.literals.classification', removeOnEset: false, editPermissions: !vm.diligenceId ? vm.newPerm : undefined,
                    onSelected: function(item) {
                        $rootScope.$broadcast('registerEntryClassificationChanged', {defaultExtract: item.defaultExtract});
                    }
                },
                { type: 'field', id: 'extract', fieldType: 'textarea', colClass: 'col-sm-12', required: false, label: 'global.literals.extract',
                    controller: ['$scope', function($scope) {
                        $scope.$on('registerEntryClassificationChanged', function (event, args) {
                            $scope.model.extract = args.defaultExtract;
                        });
                    }]
                },
                uniqueWindowField,
                { type: 'field', id: 'originRegisterDate', fieldType: 'date', colClass: 'col-sm-12', required: false, label: 'global.literals.originRegisterInputDate', hideExpression: hideUniqueWindow, showIf: showIfUniqueWindow },
                { type: 'field', id: 'originEntryNumber', fieldType: 'text', colClass: 'col-sm-12', required: false, label: 'global.literals.originEntryInputNumber', hideExpression: hideUniqueWindow, showIf: showIfUniqueWindow },
                { type: 'field', id: 'originRegisterOrgan', fieldType: 'text', colClass: 'col-sm-12', required: false, label: 'global.literals.originEntryInputOrgan', hideExpression: hideUniqueWindow, showIf: showIfUniqueWindow },
                { type: 'field', id: 'destinyRegisterDate', fieldType: 'date', colClass: 'col-sm-12', required: false, label: 'global.literals.destinyRegisterInputDate', hideExpression: hideUniqueWindow, showIf: showIfUniqueWindow },
                { type: 'field', id: 'destinyEntryNumber', fieldType: 'text', colClass: 'col-sm-12', required: false, label: 'global.literals.destinyEntryInputNumber', hideExpression: hideUniqueWindow, showIf: showIfUniqueWindow },
                { type: 'field', id: 'destinyRegisterOrgan', fieldType: 'text', colClass: 'col-sm-12', required: false, label: 'global.literals.destinyEntryInputOrgan', hideExpression: hideUniqueWindow, showIf: showIfUniqueWindow },
                { type: 'field', id: 'observations', fieldType: 'textarea', colClass: 'col-sm-12', required: false, label: 'global.literals.observations' }
            ]


            if($rootScope.app.configuration.multiple_register_office && $rootScope.app.configuration.multiple_register_office.active && GlobalDataFactory.registerEntryOffices.length > 1) {
                var registerOfficeField = {
                    type: 'field',
                    id: 'registerEntryOffice',
                    fieldType: 'select',
                    data: GlobalDataFactory.registerEntryOffices,
                    colClass: getColClass('registerEntryOffice'),
                    required: true,
                    label: 'global.literals.register_office',
                    editPermissions: 'not_allowed',
                    onSelected: function(item) {
                    	var registerEntryChannel = $linq(vm.newRegisterEntryInputFormFields).where("x => x.id == 'registerEntryChannel'").toArray();
                    	
                		if (vm.entryType == 'INPUT' && item.registerEntryInputChannel) {
                			if(registerEntryChannel && registerEntryChannel.length > 0) {
                				$rootScope.$broadcast('registerEntryOfficeChanged', {item: item.registerEntryInputChannel});
                			}
                		}
                	}
                }

                var indexRegisterEntryChannel = $linq(vm.newRegisterEntryInputFormFields).indexOf("x => x.id == 'registerEntryChannel'");

                if(indexRegisterEntryChannel == -1) {
                    vm.newRegisterEntryInputFormFields.unshift(registerOfficeField);
                } else {
                    vm.newRegisterEntryInputFormFields.splice(indexRegisterEntryChannel, 0, registerOfficeField);
                }
            }

            if(vm.registerEntry && vm.registerEntry.id && vm.entryType != 'OUTPUT'){
                var efectiveDate = {
                    type: 'field',
                    id: 'effectiveDate',
                    fieldType: 'date',
                    colClass: 'col-sm-6',
                    required: true,
                    label: 'global.literals.effectiveDate',
                    isReadOnly:false
                }
                                
                var efectiveTime = {
                        type: 'field',
                        id: 'effectiveTime',
                        value: vm.registerEntry.effectiveDate,
                        fieldType: 'time',
                        colClass: 'col-sm-6',
                        required: true,
                        label: 'global.literals.time',
                        isReadOnly:false
                    }
                
                var indexPresentationTime = $linq(vm.newRegisterEntryInputFormFields).indexOf("x => x.id == 'presentationTime'");

                if(indexPresentationTime == -1) {
                    vm.newRegisterEntryInputFormFields.splice(0, 0, efectiveDate);
                    vm.newRegisterEntryInputFormFields.splice(1, 0, efectiveTime);
                } else {
                    vm.newRegisterEntryInputFormFields.splice(indexPresentationTime+1, 0, efectiveDate);
                    vm.newRegisterEntryInputFormFields.splice(indexPresentationTime+2, 0, efectiveTime);
                }
            }
            vm.submit = function() {
                var validBox = true;

                this.form.$setSubmitted();

                if($rootScope.app.configuration.reg_init_dossier_diligence_type_required.value && vm.entryType == 'INPUT' && !vm.fromDossier) {
                    if($linq(vm.diligencesBox.content).count("x => x.diligenceType.canStartDossier") == 0) {
                        if(vm.isModal) {
                            DialogsFactory.error($filter('translate')('global.errors.requiredinitdossierdiligence'));
                        } else {
                            vm.alerts.push({msg: 'global.errors.requiredinitdossierdiligence'});
                        }

                        validBox = validBox && false;
                    }
                }

                if($rootScope.app.configuration.reg_thirds_required.value) {
                    if(!vm.thirdBox.content || vm.thirdBox.content.length == 0) {
                        if(vm.isModal) {
                            DialogsFactory.error($filter('translate')(vm.entryType == 'INPUT' ? 'global.errors.requiredthirdsinregisterentryinput' : 'global.errors.requiredthirdsinregisterentryoutput'));
                        } else {
                            vm.alerts.push({msg: vm.entryType == 'INPUT' ? 'global.errors.requiredthirdsinregisterentryinput' : 'global.errors.requiredthirdsinregisterentryoutput'});
                        }

                        validBox = validBox && false;
                    }
                }

                if(this.form.$valid && validBox) {
                	
                	var archiveClassification = undefined;
                    if(this.model.archiveClassification && this.model.archiveClassification.$selected && this.model.archiveClassification.$selected.id){
                        archiveClassification = {id:this.model.archiveClassification.$selected.id};
                    }
                	
                    var newRegisterEntry = {
                        registerEntryOffice: this.model.registerEntryOffice ? (this.model.registerEntryOffice.id ? { id: this.model.registerEntryOffice.id } : { id: this.model.registerEntryOffice }) : GlobalDataFactory.defaultRegisterEntryOffice,
                        entryType: vm.entryType,
                        presentationDate: this.model.presentationDate && this.model.presentationTime ?
                            Date.UTC(this.model.presentationDate.getFullYear(), this.model.presentationDate.getMonth(), this.model.presentationDate.getDate(), this.model.presentationTime.getUTCHours(), this.model.presentationTime.getUTCMinutes()) :
                            this.model.presentationDate,
                        registerEntryChannel: isNaN(this.model.registerEntryChannel) ? this.model.registerEntryChannel : { id: this.model.registerEntryChannel },
                        documentDate: this.model.documentDate,
                        entryDocumentType: this.model.entryDocumentType ? { id: this.model.entryDocumentType } : undefined,
                        entryClassification: this.model.entryClassification ? { id: this.model.entryClassification } : undefined,
                        extract: this.model.extract,
                        observations: this.model.observations,
                        profile: this.model.profile ? (this.model.profile.id ? { id: this.model.profile.id } : { id: this.model.profile }) : undefined,
                        section: this.model.section ? (this.model.section.id ? { id: this.model.section.id } : { id: this.model.section }) : undefined,
                        uniqueWindow: this.model.uniqueWindow_1,
                        originRegisterDate: this.model.uniqueWindow_1 ? this.model.originRegisterDate : undefined,
                        originEntryNumber: this.model.uniqueWindow_1 ? this.model.originEntryNumber : undefined,
                        originRegisterOrgan: this.model.uniqueWindow_1 ? this.model.originRegisterOrgan : undefined,
                        destinyRegisterDate: this.model.uniqueWindow_1 ? this.model.destinyRegisterDate : undefined,
                        destinyEntryNumber: this.model.uniqueWindow_1 ? this.model.destinyEntryNumber : undefined,
                        destinyRegisterOrgan: this.model.uniqueWindow_1 ? this.model.destinyRegisterOrgan : undefined,
                        thirds: [],
                        documents: [],
                        entryDiligences: [],
                        relatedDossiers: [],
                        relatedEntries: [],
                        tasks: [],
                        tasksOutput: [],
                        notifications: [],
                        addresses: [],
                        archiveClassification: archiveClassification,
                        tramClassification: this.model.tramClassification ? (this.model.tramClassification.id ? { id: this.model.tramClassification.id } : { id: this.model.tramClassification }) : undefined
                    }

                    _.forEach(vm.thirdBox.content, function(item) {
                        if(item) {
                            newRegisterEntry.thirds.push({
                                third: {id: item.third.id},
                                interested: item.interested != undefined ? item.interested : false,
                                roleInterested: item.roleInterested ? {id: (item.roleInterested.id ? item.roleInterested.id : item.roleInterested)} : undefined,		
                                representative: item.representative != undefined ? item.representative : false,
                                principal: item.principal,
                                representated: item.representated ? {id: (item.representated.id ? item.representated.id : item.representated)} : undefined,
                                thirdAddress: item.thirdAddress ? {id: (item.thirdAddress.id ? item.thirdAddress.id : item.thirdAddress)} : undefined
                            });
                        }
                    });

                    _.forEach(vm.documentBox.content, function(item) {
                        if(item) {
                            newRegisterEntry.documents.push({
                            	document: {id: item.document.id},
                            	relationType: item.relationType
                            });
                        }
                    })

                    _.forEach(vm.diligencesBox.content, function(item) {
                        if(item) {
                            var newDiligence = {
                                diligenceType: item.diligenceType,
                                diligenceProfile: {id: item.diligenceProfile.id},
                                diligenceState: item.diligenceState,
                                registerEntryDiligenceComments: [],
                                responsibleUser: ((item.responsibleUser && item.responsibleUser.id)? {id:item.responsibleUser.id} :  undefined)
                            };

                            _.forEach(item.registerEntryDiligenceComments, function (com) {
                                newDiligence.registerEntryDiligenceComments.push({
                                    createdUser: {id: $rootScope.LoggedUser.id},
                                    comments: com.comments
                                });
                            });

                            newRegisterEntry.entryDiligences.push(newDiligence);
                        }
                    });

                    _.forEach(vm.dossierBox.content, function(item) {
                        if(item) {
                            newRegisterEntry.relatedDossiers.push({dossier:{id: item.id}});
                        }
                    });
                    if(vm.registerEntryBox && vm.registerEntryBox.content && vm.registerEntryBox.content.length > 0){
                    	newRegisterEntry.relatedFromEntries = [];
	                    _.forEach(vm.registerEntryBox.content, function(item) {
	                        if(item) {
	                            newRegisterEntry.relatedFromEntries.push(({related: {id:item.id}}));
	                        } 
	                    });
                    }
                    _.forEach(vm.taskBox.content, function (item) {
                        if(item) {
                            if (vm.entryType == 'INPUT') {
                                newRegisterEntry.tasks.push({id: item.id});
                            } else {
                                newRegisterEntry.tasksOutput.push({id: item.id});
                            }
                        }
                    });

                    _.forEach(vm.notificationsBox.content, function (item) {
                        if(item) {
                        	//Si estoy en tramites
                        	if($state.current.name.startsWith('annexa.tram') && vm.isModal && TramNewFactory.Dossier && TramNewFactory.Dossier.id){
                        		item.dossier = {id: TramNewFactory.Dossier.id};
                        	}
                            newRegisterEntry.notifications.push(item);
                        }
                    });
                    
                    _.forEach(vm.addressBox.content, function (item) {
                        if(item) {
                        	newRegisterEntry.addresses.push({
                            	address: {id: item.address.id}
                            });
                        }
                    });

                    RegFactory.createRegisterEntry(newRegisterEntry)
                        .then(function(data) {
                            if(vm.isModal) {
                                $rootScope.$broadcast('createdRegisterEntry', { id: 'modalNewRegisterEntry', data: data, addNotifications:($state.current.name.startsWith('annexa.tram') && vm.isModal && TramNewFactory.Dossier && TramNewFactory.Dossier.id) });
                                $rootScope.$broadcast('closeAnnexaFormModal', { id: 'modalNewRegisterEntry', data: data });
                            }
                            if(vm.redirectToList) {
                                $state.transitionTo(vm.entryType == 'INPUT' ? 'annexa.reg.input.entries' : 'annexa.reg.output.entries');
                            }
                        }).catch(function (error) {
                            $rootScope.$broadcast('dummy');
                            if(vm.isModal) {
                                DialogsFactory.error(ErrorFactory.getErrorMessage('register', 'new', error));
                            } else {
                                vm.alerts.push({msg: ErrorFactory.getErrorMessage('register', 'new', error)});
                            }
                    })
                }
            }

            vm.alerts = [];

            //endregion

            //region Thrids Box

            $scope.$on('annexaBoxThirdsDelete', function (event, args) {
                if(args.origin && args.origin == 'annexa-box-object-reg' && vm.isEdit) {
                    RegFactory.deleteRegisterEntryThird(vm.registerEntry.id, args.removedIds)
                        .then(function(data) {
                            if(data.data != -1) {
                                var indexNewPrincipal = $linq(vm.thirdBox.content).indexOf("x => x.id == " + data.data);

                                if(indexNewPrincipal != -1) {
                                    vm.thirdBox.content[indexNewPrincipal].principal = true;
                                }
                            }
                            RegFactory.regEntry.thirds = vm.registerEntry.thirds;
                        }).catch(function(error) {
                            console.log(error);
                    })
                }
            });

            $scope.$on('annexaBoxThirdsSetPrincipal', function (event, args) {
                if(args.origin && args.origin == 'annexa-box-object-reg' && vm.isEdit) {
                    RegFactory.setPrincipalRegisterEntryThird(vm.registerEntry.id, args.id)
                        .then(function() {
                        	RegFactory.regEntry.thirds = vm.registerEntry.thirds;
                        }).catch(function(error) {
                        console.log(error);
                    })
                }
            });

            var addThirdSave = function(newThird) {
                var newRegisterEntryThird = {
                    registerEntry: { id: vm.registerEntry.id },
                    third: { id: newThird.third.id },
                    interested: newThird.interested == undefined ? false : newThird.interested,
                    roleInterested: newThird.roleInterested ? { id: (typeof newThird.roleInterested == 'number' ? newThird.roleInterested : newThird.roleInterested.id) } : undefined,
                    representative: newThird.representative == undefined ? false : newThird.representative,
                    representated: newThird.representated ? { id: (typeof newThird.representated == 'number' ? newThird.representated : newThird.representated.id) } : undefined,
                    principal: newThird.principal == undefined ? false : newThird.principal,
                    thirdAddress: newThird.thirdAddress ? {id: newThird.thirdAddress} : undefined
                }

                RegFactory.newRegisterEntryThird(vm.registerEntry.id, newRegisterEntryThird)
                    .then(function(data) {
                    	if (vm.registerEntry) {
                    		newThird.id = data.id;
                    		if (vm.registerEntry.thirds == null || vm.registerEntry.thirds == undefined) {
                    			vm.registerEntry.thirds = [];
                    		}
                    		vm.registerEntry.thirds.push(newThird);
                    		RegFactory.regEntry.thirds = vm.registerEntry.thirds;
                    	}
                    }).catch(function (error) {
                        console.error(error)
                });
            }

            //endregion

            //region Documents Box

            $scope.$on('annexaBoxDocumentsDelete', function (event, args) {
                if(args.origin && args.origin == 'annexa-box-object-reg' && vm.isEdit) {
                    RegFactory.deleteRegisterEntryDocument(vm.registerEntry.id, args.removedId)
                        .then(function () {
                            //Empty
                        }).catch(function(error) {
                            console.error(error);
                    });
                }
            });

            var addDocumentSave = function(newRegisterEntryDocument) {
                $rootScope.loading(true);
                
                RegFactory.newRegisterEntryDocument(vm.registerEntry.id, newRegisterEntryDocument)
                    .then(function(data) {
                    	vm.documentBox.content.length =0;
                    	_.forEach(data.documents, function(doc){
                    		 vm.documentBox.content.push(doc);
                    	});
                    	$rootScope.$broadcast('annexaBoxDocumentsUpdateCounter', { content: vm.documentBox.content, relationType: 'DOCUMENT'});
                        $rootScope.loading(false);
                    }).catch(function (error) {
                        $rootScope.loading(false);
                        console.error(error);
						if(error && error.data && error.data.message === "Is not valid document from template not found"){
							vm.alerts.push({ msg: 'global.documents.definitiveNotificationNoValidError'});
                        }else if (error.data && error.data.message) {
                        	vm.alerts.push({ msg: error.data.message });
						} else {
                        	vm.alerts.push({ msg: 'global.errors.errorCreateDocument' });
                        }
                });
            }

            //endregion

            //region Diligences Box

            $scope.$on('annexaBoxDiligencesDelete', function (event, args) {
                if(args.origin && args.origin == 'annexa-box-object-reg' && vm.isEdit) {
                    RegFactory.deleteRegisterEntryDiligence(vm.registerEntry.id, args.removedId)
                        .then(function () {
                            //Empty
                        }).catch(function(error) {
                        console.error(error);
                    });
                }
            });

            var addDiligence = function(newDiligence) {
                RegFactory.newRegisterEntryDiligence(vm.registerEntry.id, newDiligence)
                    .then(function(data) {
                        vm.diligencesBox.content.push(data);
                    }).catch(function(error) {
                    	vm.alerts.push({msg: ErrorFactory.getErrorMessage('register', 'new', error)});
                });
            }

            //endregion

            //region Dossier Box

            $scope.$on('annexaBoxDossiersDelete', function (event, args) {
                if(args.origin && args.origin == 'annexa-box-object-reg' && vm.isEdit) {
                    RegFactory.deleteRegisterEntryDossier(vm.registerEntry.id, args.removedId)
                        .then(function () {
                            //Empty
                        }).catch(function(error) {
                        console.error(error);
                    });
                }
            });

            var addDossierSave = function(newDossier) {
                RegFactory.newRegisterEntryDossier(vm.registerEntry.id,  $linq(newDossier).select("x => x.id").toArray())
                    .then(function(data) {
                        //Empty
                    }).catch(function(error) {
                        console.error(error);
                });
            }

            //endregion

            //region RegisterEntry Box

            var addRegisterEntrySave = function(newRegisterEntry) {
                RegFactory.newRegisterEntryRelatedRegisterEntry(vm.registerEntry.id, $linq(newRegisterEntry).select("x => x.id").toArray())
                    .then(function(data) {
                    	var regids = $linq(newRegisterEntry).select("x => x.id").toArray();
                    	if(vm.registerEntry.relatedEntries){
                    		vm.registerEntry.relatedEntries.length = 0;
                    	}else{
                    		vm.registerEntry.relatedEntries = [];
                    	}
                    	_.forEach(data, function(d){
                    		vm.registerEntry.relatedEntries.push(d);
                    	});
                    }).catch(function(error) {
                        console.error(error);
                });
            }

            $scope.$on('annexaBoxRegisterEntriesDelete', function (event, args) {
                if(args.origin && args.origin == 'annexa-box-object-reg' && vm.isEdit) {
                    RegFactory.deleteRegisterEntryRelatedRegisterEntry(vm.registerEntry.id, args.removedId)
                        .then(function (data) {
                        	var copyrelated = angular.copy(vm.registerEntry.relatedEntries);
                        	if(vm.registerEntry.relatedEntries){
                        		vm.registerEntry.relatedEntries.length = 0;
                        	}else{
                        		vm.registerEntry.relatedEntries = [];
                        	}
                        	var entries = ((data && data.data)?JSOG.decode(data.data):[]);
                        	_.forEach(entries, function(d){
                        		vm.registerEntry.relatedEntries.push(d);
                        	});
                        }).catch(function(error) {
                            console.error(error);
                    });
                }
            });

            //endregion

            //region Notifications Box

			var createMultipleNotifications = function (notifications, modal) {
                NotificationFactory.createMultipleNotifications(notifications).then(function(data) {
                    _.forEach(data, function (item) {
                        vm.notificationsBox.content.push(item);
                    });
                }).catch(function (error) {
                	if(error && error.data && error.data.message == 'No notification type'){
                		DialogsFactory.error($filter('translate')('global.sec.errors.noNotificationType'));
                	}else if(error && error.data && error.data.message == 'channelNoValidSendNotifications'){
                		DialogsFactory.error($filter('translate')('global.errors.channelNoValidSendNotifications'));
                	}else if(error && error.data && error.data.code && error.data.code.toUpperCase() == 'Template Exception'.toUpperCase()){
						var msg = $filter('translate')('global.tram.errors.processTemplate')+((error.data.message)?'<br/><br/>'+error.data.message:'');
						DialogsFactory.error(msg, $filter('translate')('DIALOGS_ERROR_MSG'));
					}else if(error && error.data && error.data.message === "Is not valid document from template not found"){
						DialogsFactory.error($filter('translate')('global.documents.definitiveNotificationNoValidError'));
					}else{
                		DialogsFactory.error($filter('translate')('global.errors.unknownNew'));
                	}
                    console.error(error);
                });
                if (modal) modal.close();
			}

            var addNotificationSave = function (notifications, modal) {
            	var checkNotifiableRecipients = ($rootScope.app.configuration.check_notifiable_recipients && $rootScope.app.configuration.check_notifiable_recipients.active)?$rootScope.app.configuration.check_notifiable_recipients.active:false;
            	if (checkNotifiableRecipients) {
            		var telematicNotifications = $linq(notifications).where("x => x.notificationType && x.notificationType.addressType && (x.notificationType.addressType == 'TELEMATIC_EMAIL' || x.notificationType.addressType == 'OTHER')").toArray();
            		if (!telematicNotifications) telematicNotifications = [];
            		
            		NotificationFactory.checkNotifiableRecipients(telematicNotifications).then(function(data) {
            			if (data) {
            				var keys = Object.keys(data);
            				if (modal) {
            					modal.alerts.length = 0;
            					var thirdsNoti = $linq(notifications).selectMany("x => x.thirds").toArray();
        			    		_.forEach(keys, function(key){
        			    			var thirdNoti = $linq(thirdsNoti).firstOrDefault(undefined,"x => x.third && x.third.id == "+key+"");
        			    			if(data[key] == 'No check notifiable recipient configuration'){
	    								modal.alerts.push({msg:thirdNoti.third.completeName + " - " + $filter('translate')('global.errors.noCheckNotifiableRecipientConfiguration')});
        			    			} else if(data[key] == 'Error call to PDI') {
	    								modal.alerts.push({msg:thirdNoti.third.completeName + " - " + $filter('translate')('global.errors.errorCheckNotifiableRecipients')});
        			    			} else {
        			    				modal.alerts.push({msg:thirdNoti.third.completeName + " - " + data[key]});
        			    			}
        	                    });
            				}
            			} else {
            				createMultipleNotifications(notifications, modal);
            			}
            		}).catch(function (error) {
                    	console.error(error);
                    });
            	} else {
            		createMultipleNotifications(notifications, modal);
            	}
            }
            
            var updateDouments = function(registerEntry) {
                if(registerEntry.documents){
                	vm.documentBox.content = registerEntry.documents;
                	$rootScope.$broadcast('annexaBoxDocumentsUpdateCounter', { content: vm.documentBox.content, relationType: 'DOCUMENT'});
                    $rootScope.loading(false);
                }
            }

            //endregion

            //region Task Box

            var addTaskSave = function (newTask) {
                RegFactory.newRegisterEntryTask(vm.registerEntry.id, $linq(newTask).select("x => x.id").toArray())
                    .then(function (data) {
                        //Empty
                    }).catch(function(error) {
                        console.error(error);
                });
            }

            
            var addAddressSave = function (newAddress) {
                $rootScope.loading(true);
                    
            	RegFactory.newRegisterEntryAddress(vm.registerEntry.id, newAddress)
                    .then(function (data) {
                    	vm.addressBox.content.length =0;
                    	_.forEach(data.addresses, function(address){
                    		 vm.addressBox.content.push(address);
                    	});
                        $rootScope.loading(false);
                    }).catch(function(error) {
                    	$rootScope.loading(false);
                        console.error(error);
                        if (error.data && error.data.message) {
                        	vm.alerts.push({ msg: error.data.message });
                        } else {
                        	vm.alerts.push({ msg: 'global.errors.unknownNew' });
                        }
                });
            }

            $scope.$on('annexaBoxTasksDelete', function (event, args) {
                if(args.origin && args.origin == 'annexa-box-object-reg' && vm.isEdit) {
                    RegFactory.deleteRegisterEntryTask(vm.registerEntry.id, args.removedId)
                        .then(function () {
                            //Empty
                        }).catch(function(error) {
                            console.error(error);
                    });
                }
            });

            
            $scope.$on('annexaBoxAddressDelete', function (event, args) {
                if(args.origin && args.origin == 'annexa-box-object-reg' && vm.isEdit) {
                    RegFactory.deleteRegisterEntryAddress(vm.registerEntry.id, args.removedId)
                        .then(function () {
                            //Empty
                        }).catch(function(error) {
                            console.error(error);
                    });
                }
            });

            //endregion

            //region General Box

            var getEditPermissions = function(type) {
                var canEdit = false;

                if(vm.registerEntry && vm.registerEntry.annulled){
                	canEdit = false;
                }else{
	                if(vm.diligenceId && type == 'tasks') {
	                    canEdit =
	                        (vm.registerEntryDiligence.diligenceType.type == 'ACCEPTANCE' && vm.registerEntryDiligence.diligenceState == 'ACCEPT') ||
	                        (vm.registerEntryDiligence.diligenceType.type == 'ACCESS' && vm.registerEntryDiligence.diligenceState != 'FINISHED' && vm.registerEntryDiligence.diligenceState != 'REJECT');
	                } else {
	                    if (type == 'diligences' || type == 'registerEntries') {
	                        canEdit = true;
	                        
	                    } else {
	
	                        var editDays = -1;
	
	                        if (vm.isEdit) {
	                            editDays = vm.registerEntry.registerEntryOffice.registerEntryEditDays;
	                        }
	
	                        if (editDays == -1) {
	                            canEdit = true;
	                        } else {
	                            var daysFromEdit = HelperService.diffDateDays(vm.registerEntry.createdDate, new Date());
	
	                            if (daysFromEdit <= editDays) {
	                                canEdit = true;
	                            }
	                        }
	                    }
                	}
                }
                
                var permissions = [];
                if(!canEdit) {
                	return type ? {}:[];
                } else {
                    if(AnnexaPermissionsFactory.havePermission(vm.editPerm)) {
                        permissions.push(vm.editPerm);
                    }

                    if(AnnexaPermissionsFactory.havePermission(vm.newPerm)) {
                        permissions.push(vm.newPerm);
                    }
                }
                
                if (permissions.length > 0) {
	                switch (type) {
	                    case 'thirds':
	                        return (vm.isEdit && canEdit) || !vm.isEdit ? { new: 'new_third', view: vm.newPerm } : {};
	                        break;
	                    case 'documents':
	                        return (vm.isEdit && canEdit) || !vm.isEdit ? { new: 'new_document', view: vm.newPerm } : {};
	                        break;
	                    case 'diligences':
	                        return !vm.diligenceId || (vm.isEdit && canEdit) ? { new: 'new_input_entry_register' } : {};
	                        break;
	                    case 'dossiers':
	                        return (vm.isEdit && canEdit) || !vm.isEdit ? { view: vm.newPerm } : {};
	                        break;
	                    case 'registerEntries':
	                        return (vm.isEdit && canEdit) || !vm.isEdit ? { view: vm.newPerm } : {};
	                        break;
	                    case 'notifications':
	                        return (vm.isEdit && canEdit) || !vm.isEdit ? { new: vm.newPerm } : {};
	                        break;
	                    case 'tasks':
	                        return (vm.isEdit && canEdit) || !vm.isEdit ? { new: vm.newPerm, view: vm.newPerm } : {};
	                        break;
	                    case 'address':
	                        return (vm.isEdit && canEdit) || !vm.isEdit ? { new: vm.newPerm, view: vm.newPerm } : {};
	                        break;
	                    default:     
	                    	return permissions;
	                        break;
	                }
                } else {
                	return type ? {}:[];
                }
                
            }

            //endregion

            this.$onInit = function() {
            	
            	if($stateParams.registerEntryId && RegFactory.regEntry && RegFactory.regEntry.id == $stateParams.registerEntryId) {
            		vm.registerEntry = {};
            		vm.registerEntry.thirds = ((RegFactory.regEntry.thirds)?angular.copy(RegFactory.regEntry.thirds):[]);
            		vm.registerEntry.documents = ((RegFactory.regEntry.documents)?angular.copy(RegFactory.regEntry.documents):[]);
            		vm.registerEntry.relatedEntries = [];
            		vm.registerEntry.relatedEntries.push(RegFactory.regEntry);
            	}

                vm.newPerm = vm.entryType == 'INPUT' ? 'new_input_entry_register' : 'new_output_entry_register';
                vm.editPerm = vm.entryType == 'INPUT' ? 'edit_input_entry_register' : 'edit_output_entry_register';
                vm.module = vm.entryType == 'INPUT' ? 'REGENTRADA' : 'REGSALIDA';
				vm.requiredResponsible = ($rootScope.esetMode || 
					(
						$rootScope.app && $rootScope.app.configuration &&  $rootScope.app.configuration.assign_responsible_user && $rootScope.app.configuration.assign_responsible_user.registerEntryDiligence && 
						$rootScope.app.configuration.assign_responsible_user.registerEntryDiligence == 'Obligatoria'
					)
				)
                vm.registerEntryDiligence = undefined;
                vm.registerEntryDiligenceState = undefined;

                if(vm.registerEntry && vm.diligenceId) {
                    var indexDiligence = $linq(vm.registerEntry.entryDiligences).indexOf("x => x.id == " + vm.diligenceId);

                    if(indexDiligence != -1) {
                        vm.registerEntryDiligence = vm.registerEntry.entryDiligences[indexDiligence];
                        vm.registerEntryDiligenceState = $filter('translate')('global.reg.diligenceState.' + vm.registerEntryDiligence.diligenceState);
                    }
                }
                
                vm.getLastAudit();

                vm.updateOpenProfileStatus = function(isOpen, profile){
                	if(isOpen && profile && profile.id && (!profile.userProfiles || profile.userProfiles.length == 0)){
                		 RestService.findOne('Profile', profile.id, 'exportProfile').then(function (data) {
                             var pAux = JSOG.decode(data.data);
                             if(pAux.userProfiles && pAux.userProfiles.length > 0){
                            	 profile.userProfiles = pAux.userProfiles;
                             }
                         });
                	}
                }
                //region Init Boxs

                vm.editPermissions = getEditPermissions();

                var thirdIdentificationDocumentTypesFilter = undefined;

                if($rootScope.app.configuration.reg_thirds_permited_identification_document_types.value) {
                    thirdIdentificationDocumentTypesFilter = {
                        thirdIdentificationDocumentTypes: $rootScope.app.configuration.reg_thirds_permited_identification_document_types.value
                    }
                }
                thirdIdentificationDocumentTypesFilter.searchBox = true;
                thirdIdentificationDocumentTypesFilter.active = true;

                vm.thirdBox = {
                    boxTitle: vm.entryType == 'INPUT' ? 'global.literals.origin' : 'global.literals.destiny',
                    permissions: getEditPermissions('thirds'),
                    search: {
                        placeholder: 'global.literals.placeholder_search_receiver',
                        advanced: true,
                        saveSearch: vm.isEdit ? addThirdSave : undefined,
                        additionalFilter: thirdIdentificationDocumentTypesFilter,
                    },
                    content: ((vm.registerEntry && vm.registerEntry.thirds) ? vm.registerEntry.thirds : ((vm.preloadBoxes && vm.preloadBoxes.thirds) ? vm.preloadBoxes.thirds : [])),
                    new: {},
                    config: {viewConsentAll:true},
                    origin: 'annexa-box-object-reg'
                }

                $rootScope.$broadcast('dummy');

                vm.documentBox = {
                    permissions: getEditPermissions('documents'),
                    search: {
                        placeholder: 'global.literals.placeholser_search_documents',
                        advanced: true,
                        saveSearch: vm.isEdit ? addDocumentSave : undefined,
                        addAfter: true,
                        additionalFilter: { exceptState: 'NEW', documentBoxNormalSearch: true, includeRegisterEntry: ((vm.module === 'REGSALIDA')?true:null) }
                    },
                    content: ((vm.registerEntry && vm.registerEntry.documents) ? vm.registerEntry.documents : ((vm.preloadBoxes && vm.preloadBoxes.documents) ? vm.preloadBoxes.documents : [])),
                    new: { multiple: { scanner: true }},
                    config: { documentTitle: undefined, module: vm.module, thirdBox: vm.thirdBox },
                    origin: 'annexa-box-object-reg'
                }
				vm.documentBox.new.associateThirdDocuments = function(){
					DccumentsFactory.associateThirdDocuments(vm.documentBox.content, vm.thirdBox.content, 'reg');
				}
				vm.documentBox.new.showAssociateThirdDocuments = true;
				vm.documentBox.new.thirds = vm.thirdBox.content;
				$scope.$on('associateThirdDocumentsRegFinish', function (event, args) {
                    if (args.docs && args.docs.length > 0 && args.origin === 'reg') {
						if(vm.isEdit){
							var docsToAdd = [];
							_.forEach(args.docs, function(value){
		                        docsToAdd.push({
		                            document:value,
		                            relationType: 'DOCUMENT'
	                        	});
		                    });
							addDocumentSave(docsToAdd);
						}else{
							_.forEach(args.docs, function(value){
		                        vm.documentBox.content.push({
		                            document:value,
		                            relationType: 'DOCUMENT'
	                        	});
		                    });
							$rootScope.$broadcast('annexaBoxDocumentsUpdateCounter', { content: vm.documentBox.content, relationType: 'DOCUMENT'});	
						}
                        if(args.modal){
							args.modal.close()
						}
                    }
                });

                vm.diligencesBox = {
                    permissions: getEditPermissions('diligences'),
                    search: { saveSearch: vm.isEdit ? addDiligence : undefined, addAfter: true },
                    content:  ((vm.registerEntry && vm.registerEntry.entryDiligences) ?  vm.registerEntry.entryDiligences : []),
                    new: {},
                    config: {},
                    origin: 'annexa-box-object-reg'
                }
                var relatedDossiers = [];
                if(vm.registerEntry){
                	if(vm.registerEntry.relatedDossiers){
                		relatedDossiers = $linq(vm.registerEntry.relatedDossiers).select("x => x.dossier").toArray();
                	}
                }else if(vm.preloadBoxes && vm.preloadBoxes.dossiers){
                	relatedDossiers = vm.preloadBoxes.dossiers;
                }
                vm.dossierBox = {
                    permissions: getEditPermissions('dossiers'),
                    search: { placeholder: 'global.literals.placeholder_search_dossiers', advanced: true, saveSearch: vm.isEdit ? addDossierSave : undefined },
                    content:  relatedDossiers,
                    config: {},
                    origin: 'annexa-box-object-reg'
                }

                var createList = function(relatedRegEntry){
                	var relatedRegEntryAux = ((relatedRegEntry)?angular.copy(relatedRegEntry):[]);
                    if(relatedRegEntry){
                		if(relatedRegEntry){
                			relatedRegEntry.length = 0;
                    	}else{
                    		relatedRegEntry = [];
                    	}
                	}
                	_.forEach(relatedRegEntryAux, function(related){
                    	if(related.actual && related.actual.id == vm.registerEntry.id && related.related){
                    		related.related.isRelated = true;
                    		related.related.relatedId = related.id;
                    		relatedRegEntry.push(related.related);
                    	}else if(related.related && related.related.id == vm.registerEntry.id && related.actual){
                    		related.related.isRelated = false;
                    		related.related.relatedId = related.id;
                    		relatedRegEntry.push(related.actual);
                    	}else if(related.entryType){
                    		relatedRegEntry.push(related);
                    	}
                    });
                }
                var relatedRegEntry = ((vm.registerEntry && vm.registerEntry.relatedEntries)?angular.copy(vm.registerEntry.relatedEntries):[]);
                createList(relatedRegEntry);
                vm.registerEntryBox = {
                    permissions: getEditPermissions('registerEntries'),
                    search: { placeholder: 'global.literals.placeholser_search_registerEntry', advanced: true, saveSearch: vm.isEdit ? addRegisterEntrySave : undefined },
                    content:  relatedRegEntry,
                    config: {},
                    origin: 'annexa-box-object-reg'
                }

                vm.notificationsBox = {
                    permissions: getEditPermissions('notifications'),
                    search: { saveSearch: vm.isEdit ? addNotificationSave : undefined },
                    content:  ((vm.registerEntry && vm.registerEntry.notifications) ?  vm.registerEntry.notifications : []),
                    new: {},
                    config: { thirdBox: vm.thirdBox, documentBox: vm.documentBox, registerEntry: vm.registerEntry, updateDocumentsFunction: updateDouments },
                    origin: 'annexa-box-object-reg',
                    isModal:vm.isModal
                }

                vm.taskBox = {
                    permissions: getEditPermissions('tasks'),
                    search: { placeholder: 'global.literals.placeholderSearchTaskBox', advanced: true, saveSearch: vm.isEdit ? addTaskSave : undefined },
                    content:  ((vm.registerEntry) ?  ((vm.entryType == 'INPUT') ? ((vm.registerEntry.tasks)?vm.registerEntry.tasks :[]) : ((vm.registerEntry.tasksOutput)?vm.registerEntry.tasksOutput:[])) : []),
                    new: {},
                    config: {},
                    origin: 'annexa-box-object-reg'
                }
                
                vm.addressBox = {
                    permissions: getEditPermissions('address'),
                    search: { placeholder: 'global.literals.placeholderSearchAddressBox', advanced: true, saveSearch: vm.isEdit ? addAddressSave : undefined },
                    content:  ((vm.registerEntry && vm.registerEntry.addresses) ?  vm.registerEntry.addresses : []),
                    new: {},
                    config: {},
                    origin: 'annexa-box-object-reg'
                }
                
                
                var sessions = [];
                if (vm.registerEntry && vm.registerEntry.notifications && vm.registerEntry.notifications.length > 0) {
                	angular.forEach(vm.registerEntry.notifications, function (noti) {
                		if(noti.thirds && noti.thirds.length > 0) {
                			angular.forEach(noti.thirds, function (third) {
                				if(third.sessionAttendee && third.sessionAttendee.session && !$linq(sessions).contains(third.sessionAttendee.session, "(x, y) => x.id == y.id")) {
                					sessions.push(third.sessionAttendee.session);
                				}
                			});
                		}
                	});
                }
                
                vm.sessionBox = {
                    content: sessions,
                    config: {},
                    origin: 'annexa-box-object-reg',
                    isEdit: false
                }
                
                if(!TerritoryFactory.canCreateAddress()) {
                	vm.addressBox.new = undefined;
                }

                //endregion
            }
            
            vm.getLastAudit = function() {
            	if(vm.registerEntry && vm.registerEntry.id) {
	            	AuditFactory.getLastAudit('REGISTER_ENTRY', vm.registerEntry.id, 'MODIFIED')
		    	        .then(function (data) {
		    	        	vm.lastAudit = data;
		    	        }).catch(function(error) {
		    	            console.error(error);
		    	    });
            	}
            }

            //region RegisterEntry Methods

            vm.saveRegistry = function() {
                $rootScope.$broadcast('submitForm', { id: 'new-registerentry' });
            }

            vm.cancelRegistry = function() {
                if($stateParams.registerEntryId) {
                	$state.transitionTo('annexa.reg.input.entries.edit', { input: $stateParams.registerEntryId });
                } else {
                    $state.transitionTo(vm.entryType == 'INPUT' ? 'annexa.reg.input.entries' : 'annexa.reg.output.entries');
                }
            }
            
            vm.checkUpdateRegisterEntry = function(val, prop) {
            	if(vm.lastAudit && vm.registerEntry && vm.registerEntry.id) {
            		vm.checkLastAuditConfirmation(val, prop);
            	} else {
            		if(vm.registerEntry && vm.registerEntry.id) {
            			vm.checkLastAuditConfirmation(val, prop);
            		} else {
                		vm.updateRegisterEntry(val, prop);
            		}
            	}
            }
            
            vm.checkLastAuditConfirmation = function(val, prop) {
            	AuditFactory.getLastAudit('REGISTER_ENTRY', vm.registerEntry.id, 'MODIFIED')
	    	        .then(function (data) {
	    	        	if(data && vm.lastAudit && vm.lastAudit.id == data.id) {
	    	        		vm.updateRegisterEntry(val, prop);
	    	        	} else if(data) {
	    	        		var confirmBody = '';
	    	        		confirmBody = $filter('translate')('global.reg.literals.confirmReplaceModificationsBody');
	    	        		if(data.userAction || data.actionDate) {
		    	        		confirmBody += '<br/><br/><ul>';
		    	        		if(data.userAction && data.userAction.completeName) {
		    	        			confirmBody += '   <li>' + data.userAction.completeName + '</li>';
		    	        		}
		    	        		if(data.actionDate) {
		    	        			confirmBody += '   <li>' + ((data.actionDate)?$filter('date')(new Date(data.actionDate), 'dd/MM/yyyy HH:mm:ss'):'') + '</li>';
		    	        		}
		    	        		confirmBody += '</ul>';
	    	        		}
	    	        		confirmBody += $filter('translate')('global.reg.literals.confirmReplaceModificationsBody1');
	    	        		DialogsFactory.confirm($filter('translate')('global.reg.literals.confirmReplaceModificationsTitle'), confirmBody)
	            				.then(function (data) {
	            					vm.updateRegisterEntry(val, prop);
	            			}).catch(function (data) {
	            				$state.reload();
	        	            });
	    	        	} else {
	    	        		vm.updateRegisterEntry(val, prop);
	    	        	}
	    	        }).catch(function(error) {
	    	            console.error(error);
	    	    });
            }

            vm.updateRegisterEntry = function(val, prop) {
            	var archiveClassificationAux = undefined;
            	if(vm.registerEntry && vm.registerEntry.archiveClassification && vm.registerEntry.archiveClassification.options) {
            		
            		archiveClassificationAux = { 
                			model : { $selected : undefined},
                			options: vm.registerEntry.archiveClassification.options,
                			required: ""};
            		
            		if(vm.registerEntry.archiveClassification.model && vm.registerEntry.archiveClassification.model.$selected 
            				&& vm.registerEntry.archiveClassification.model.$selected.id) {
            			archiveClassificationAux = vm.registerEntry.archiveClassification;
                		vm.registerEntry.archiveClassification = $linq(GlobalDataFactory.archiveClassifications).singleOrDefault(undefined, "x => x.id == " + vm.registerEntry.archiveClassification.model.$selected.id);
                	} else {
                		vm.registerEntry.archiveClassification = undefined;
                	}
            	}
            	
            	if (prop == 'profile') {
            		vm.updateRegisterEntryProfile = true;
            		vm.oldRegisterEntryProfile = vm.registerEntry.profile;
            	} else {
            		vm.updateRegisterEntryProfile = false;
            	}
            	
                if(prop == 'managed') {
                    vm.registerEntry[prop] = val.id;
                    if(val.id) {
                        vm.registerEntry.managedUser = { id: $rootScope.LoggedUser.id };
                        vm.registerEntry.managedDate = new Date();
                    } else {
                        vm.registerEntry.managedUser = undefined;
                        vm.registerEntry.managedDate = undefined;
                    }
                } else if(prop == 'pending') {
                    vm.registerEntry[prop] = val.id;
                } else if(prop == 'archiveClassification') {
                	if(val && val.$selected && val.$selected.id) {
                		if(archiveClassificationAux && archiveClassificationAux.model) {
                			archiveClassificationAux.model = val;
                		}
                		vm.registerEntry[prop] = $linq(GlobalDataFactory.archiveClassifications).singleOrDefault(undefined, "x => x.id == " + val.$selected.id);
                	} else {
                		
                		var requiredArchiveClassification = false;
                        if(vm.entryType == 'INPUT' && $rootScope.app.configuration.required_archive_classification_register_entry) {
                            requiredArchiveClassification = $rootScope.app.configuration.required_archive_classification_register_entry.value
                        }
                        
                        if(vm.entryType == 'OUTPUT' && $rootScope.app.configuration.required_archive_classification_register_output) {
                            requiredArchiveClassification = $rootScope.app.configuration.required_archive_classification_register_output.value
                        }
                		
                		if(requiredArchiveClassification) {
                			vm.registerEntry[prop] = archiveClassificationAux;
                			return $filter('translate')('global.validation.required');
                		} else {
                			archiveClassificationAux.model.$selected = undefined;
                			vm.registerEntry[prop] = undefined;
                		}
                	}
                } else {
                    vm.registerEntry[prop] = val;
                }

                RestService.update('./api/reg/' + vm.registerEntry.id, vm.registerEntry)
                    .then(function (data) {
                        
                    	if(archiveClassificationAux) {
                    		vm.registerEntry.archiveClassification = archiveClassificationAux;
                    	}
                    	
                    	if (vm.updateRegisterEntryProfile) {
                    		if ($rootScope.app.configuration.automatic_change_documents_profile_when_change_registry_profile.value) {
                    			RestService.updateRegisterEntryDocumentsProfile(data.id, vm.oldRegisterEntryProfile.id, data.profile.id).then(function (data3) {
                    				var a = 0;
                    				$state.reload();
                    			}).catch(function (error) {
                    				DialogsFactory.error($filter('translate')('global.documents.errorAutomaticChangeDocumentsProfileWhenChangeRegistryProfile'), $filter('translate')('DIALOGS_ERROR_MSG'));
            					});
                    		} else {
                    			DialogsFactory.confirm('global.documents.confirmAutomaticChangeDocumentsProfileWhenChangeRegistryProfileTitle', 'global.documents.confirmAutomaticChangeDocumentsProfileWhenChangeRegistryProfile')
                    				.then(function (data2) {
                    					RestService.updateRegisterEntryDocumentsProfile(data.id, vm.oldRegisterEntryProfile.id, data.profile.id).then(function (data3) {
                    						var a = 0;
                    						$state.reload();
                    					}).catch(function (error) {
                    						DialogsFactory.error($filter('translate')('global.documents.errorAutomaticChangeDocumentsProfileWhenChangeRegistryProfile'), $filter('translate')('DIALOGS_ERROR_MSG'));
                    					});
                    			}).catch(function (data) {
                    				$state.reload();
                	            });
                    		}
                    		
                        } else {
                        	vm.getLastAudit();
                        }
                    }).catch(function (error) {
                        console.error(error);
                });
            }

            vm.createSuportingDocument = function () {
                $rootScope.loading(true);

                RegFactory.createSupportingDocument(vm.registerEntry.id, vm.entryType, 'DOCUMENT')
                    .then(function(data) {
                        vm.documentBox.content.push(data);
                        $rootScope.$broadcast('annexaBoxDocumentsUpdateCounter', { content: vm.documentBox.content, relationType: 'INTERNAL_DOCUMENT'});
                        $rootScope.loading(false);
                        if(data && data.document && data.document.errorCFTemplate) {
                            var errorCFTemplate = {};
                            var ko = "";
                            _.forEach(Object.entries(data.document.errorCFTemplate), function (v, k) {
                                if (!errorCFTemplate.hasOwnProperty(v[0]) && v[0] != '__jsogObjectId') {
                                    if(ko === "") {
                                        ko = "<table><tr><th>"+$filter('translate')('global.documents.errorCFTemplateNom')+'</th><th class="p-l">'+$filter('translate')('global.documents.errorCFTemplateTag')+"</th></tr>"
                                    }
                                    errorCFTemplate[v[0]] = v[1];
                                    ko = ko+"<tr><td>" + v[1] + '</td><td class="p-l">' + v[0] + "</td></tr>";
                                }
                            });
                            if(errorCFTemplate && ko !== "") {
                                ko = ko+"</table>";
                                  var msgKO = '<span>'+$filter('translate')('global.documents.errorCFTemplate')+'</span>'+ko;
                                DialogsFactory.notify(msgKO, $filter('translate')('global.documents.errorCFTemplateTitle'));
                            }
                        }
                    }).catch(function(error) {
                        $rootScope.loading(false);
						if(error && error.data && error.data.exception && error.data.exception.toUpperCase().endsWith('XDocReportException'.toUpperCase())){
							var msg = $filter('translate')('global.tram.errors.processTemplate')+((error.data.message)?'<br/><br/>'+error.data.message:'');
							DialogsFactory.error(msg, $filter('translate')('DIALOGS_ERROR_MSG'));
						}else{
			            	DialogsFactory.error(ErrorFactory.getErrorMessage('register', 'supportingdocument', error && error.data ? error.data : ''));
						}
                });
            }
            
            vm.generateDocumentSicres = function () {
            	RegFactory.getFieldsSicresForm()
            	.then(function(data) {  
            		
            		var submitSendTo = function() {
                        var self = this;
                        this.form.$setSubmitted();
                        sicresModal.alerts.length = 0;
                        if(this.fieldsDefinition[0].data.model) {
                            var modelSicres = this.fieldsDefinition[0].data.model;
                            
                            RegFactory.generateDocumentSicres(RegFactory.regEntry.id, angular.toJson(modelSicres['document_sicres_button']))
                            .then(function(data) {
                            	vm.documentBox.content.push(data);
                            	$rootScope.$broadcast('annexaBoxDocumentsUpdateCounter', { content: vm.documentBox.content, relationType: 'INTERNAL_DOCUMENT'});
                                $rootScope.loading(false);
                                sicresModal.close();
                            }).catch(function(error) {
                                $rootScope.loading(false);
                                console.log(error);
                                sicresModal.alerts.push({ msg: 'global.errors.unknownNew'});
                            });
                            
                        }else{
                            sicresModal.close();
                        }
                    }
            		
            		var button = angular.fromJson('{"id":"document_sicres_button", "name":"UI Button for generate SICRES Document XML", "params":"", "returnType":"FILE_CONTENTS_FOR_DOWNLOAD"}');
            		button.params = angular.fromJson(data);
            		
                	var sicresModal = {
                		title: 'global.reg.literals.generateDocumentSicres',
                        size: '',
                        fieldsDefinition: [
                            { type: 'field', id: 'annexaRegisterDocument', fieldType: 'component', componentType: 'annexa-register-document',
                                data: {
                                    registerEntry: RegFactory.regEntry,
                                    plugin: button,
                                    model: {}
                                }
                            }
                        ],
                        alerts: [],
                        submitModal: submitSendTo
                    }
                	AnnexaFormlyFactory.showAnnexaFormModal('modalSICRES', sicresModal);
                	
                }).catch(function(error) {
                    console.log(error);
                });
            }

            $scope.$on('AnnexaProfileEditUpdated', function (event, args) {
                if(args.profile) {
                    vm.checkUpdateRegisterEntry(args.profile, 'profile');
                }
            });

            vm.auditRegisterEntry = function () {
                if (vm.registerEntry && vm.registerEntry.id) {
                    window.open($state.href('annexa.admin.audit_register_entry', {"objectId": vm.registerEntry.id}), '_blank');
                }
            };
            
            vm.duplicateRegister = function () {
            	var submitDuplicateRegister = function () {
                    var self = this;
                    this.form.$setSubmitted();

                    if(this.form.$valid) {
                    	var selectedRegisterOffice = $linq(GlobalDataFactory.registerEntryOffices).singleOrDefault(undefined, "x => x.id == " + this.model.regOffice);
                    	var newRegisterEntry = {
                    		registerEntryOffice: selectedRegisterOffice,
                    		profile: this.model.profile ? (this.model.profile.id ? { id: this.model.profile.id } : { id: this.model.profile }) : undefined,
                    		section: this.model.section ? (this.model.section.id ? { id: this.model.section.id } : { id: this.model.section }) : undefined
                    	}
                        /*var selectedRegisterOffice = $linq(GlobalDataFactory.registerEntryOffices).singleOrDefault(undefined, "x => x.id == " + this.model.regOffice);
                        var profile = this.model.profile ? (this.model.profile.id ? { id: this.model.profile.id } : { id: this.model.profile }) : undefined;
                        var section = this.model.section ? (this.model.section.id ? { id: this.model.section.id } : { id: this.model.section }) : undefined;*/

                        if(selectedRegisterOffice) {
                        	$rootScope.loading(true);

                            RegFactory.duplicateRegisterEntryDiligence(vm.registerEntry.id, newRegisterEntry, vm.registerEntryDiligence.id)
                                .then(function (data) {
                                	RegFactory.getRegisterEntryDiligenceAudit(vm.registerEntryDiligence.id).then(function(data2){
                            			if (data2) {
                                        	vm.registerEntryDiligence.registerEntryDiligenceAudits = data2;
                                        	$rootScope.$broadcast('registerEntryDiligenceAuditUpdated', { content: vm.registerEntryDiligence.registerEntryDiligenceAudits });
                                        }
                            			
                                    	$rootScope.loading(false);
                                    	if(data && data != "") {
                                            $rootScope.$broadcast('closeAnnexaFormModal', { id: 'modalDuplicateRegister' });
                                            DialogsFactory.notify('global.literals.duplicateRegOk');
                                    	}
                                	}).catch(function(error){
                                        console.error(error);
                                		DialogsFactory.error($filter('translate')('global.errors.unknownNew'));
                                	});
                                }).catch(function (error) {
                                    $rootScope.loading(false);
                                    console.error(error);
                            })
                        } else {
                            newModal.alerts.push({ msg: 'global.errors.diligenceTypeNotFound'});
                        }
                    }
                };
                
                var registerEntryOffices = [];
                _.forEach(GlobalDataFactory.registerEntryOffices, function(regEntryOffice){
                	if(vm.registerEntry.registerEntryOffice.id != regEntryOffice.id){
                    	registerEntryOffices.push(regEntryOffice);
                	}
	           	});
                
                var newModal = RegFactory.duplicateRegisterModal(submitDuplicateRegister, undefined, registerEntryOffices);

                AnnexaFormlyFactory.showAnnexaFormModal('modalDuplicateRegister', newModal);
            };

            vm.copyRegisterEntry = function () {
                var submitCopyRegisterEntry = function() {
                	var model = modal.annexaFormly.model.modal_body;
                	
                	if(model){
                		var modelAux = {
                            numCopies: model.numCopies,
                            copyInterested: model.copyInterested_1 || false,
                            copyDocuments: model.copyDocuments_1 || false,
                            copyDiligences: model.copyDiligences_1 || false,
                            copyNotifications: (model.copyInterested_1 && model.copyDocuments_1) ? (model.copyNotifications_1 || false) : false,
                            copyOther: model.copyOther_1 || false,
                            copyUserAndProfile: model.copyUserAndProfile_1 || false,
                            copyPresentationDate: model.copyPresentationDate_1 || false
                        };

                        RegFactory.copyRegisterEntry(vm.registerEntry.id, modelAux).then(function (data) {
//                        	modal.close();
                        }).catch(function (error) {
                            console.error(error);
                        });

                        modal.close();

                        var modalResult = angular.copy(RegModals.copyRegisterEntryResult);
                        AnnexaModalFactory.showModal('modalCopyRegisterEntryResult', modalResult);
					}
                };
                
            	var modal = RegModals.copyRegisterEntry;
                modal.annexaFormly.model = {};
                modal.annexaFormly.model.modal_body = {};
                modal.annexaFormly.options = {};
                modal.annexaFormly.options.formState = { readOnly: false };
                modal.annexaFormly.model.modal_body = { 
                		numCopies: 1,
                		copyInterested_1: false,
                		copyDocuments_1: false,
                		copyDiligences_1: (vm.entryType == 'INPUT' ? true : false),
                		copyNotifications_1: (vm.entryType == 'OUTPUT' ? true : false),
                		copyOther_1: false,
                		entryType: vm.entryType,
                		copyUserAndProfile_1: false,
                		copyPresentationDate_1: false
                };

                AnnexaFormlyFactory.showModal("modalCopyRegisterEntry", modal, submitCopyRegisterEntry, false);
            };
            
            vm.createRegisterOutput = function(){
                $state.transitionTo('annexa.reg.output.entries.new', {
                    "registerEntryId": vm.registerEntry.id
                });
            };

            vm.registerDocumentSync = function() {
            	RegFactory.registerDocumentSync(vm.registerEntry.id).then(function (data) {
            		if (data && data.response) {
            			DialogsFactory.notify(data.response, $filter('translate')('global.reg.literals.syncDone'));
            			$state.reload();
            		}
            	}).catch(function (error) {
            		DialogsFactory.error(ErrorFactory.getErrorMessage('register', 'syncDoc', error.data), $filter('translate')('DIALOGS_ERROR_MSG'));
            	});
            }

            $scope.annullateRegister = function(){
            	var reloadStateOrReloadTable = function(){
            		$state.reload();
            	};
            	
            	RegFactory.annullateRegister(vm.registerEntry.id, true, reloadStateOrReloadTable);
            }
            
            $scope.undoAnnullateRegister = function(){
            	var reloadStateOrReloadTable = function(){
            		$state.reload();
            	};
            	
            	RegFactory.annullateRegister(vm.registerEntry.id, false, reloadStateOrReloadTable);
            }
            //endregion

            //region Diligence Methods

            vm.diligenceResponsibleUser = function() {
                $rootScope.loading(true);
				if(vm.registerEntryDiligence && vm.registerEntryDiligence.responsibleUser && vm.registerEntryDiligence.responsibleUser.id != vm.loggedUser.id && vm.requiredResponsible){
					vm.registerEntryDiligence.responsibleUser = undefined;
				}
                RegFactory.responsibleUser(vm.registerEntryDiligence)
                    .then(function (data) {
                    	RegFactory.getRegisterEntryDiligenceAudit(vm.registerEntryDiligence.id).then(function(data2){
                			if (data2) {
                            	vm.registerEntryDiligence.registerEntryDiligenceAudits = data2;
                            	
                            	$rootScope.$broadcast('registerEntryDiligenceAuditUpdated', { content: vm.registerEntryDiligence.registerEntryDiligenceAudits });
                            }
                			
                            vm.registerEntryDiligence.responsibleUser = vm.registerEntryDiligence.responsibleUser ? undefined : $rootScope.LoggedUser;
                            $rootScope.loading(false);
                    	}).catch(function(error){
                            console.error(error);
                    		DialogsFactory.error($filter('translate')('global.errors.unknownNew'));
                    	});
                    }).catch(function (error) {
                        $rootScope.loading(false);
                        console.error(error);
                })
            }

            var updateDiligenceState = function(state, comment, modal) {
                $rootScope.loading(true);

                RegFactory.updateRegisterEntryDiligenceState(vm.registerEntryDiligence, state, comment)
                    .then(function(data) {
                        $rootScope.loading(false);
                        vm.registerEntryDiligence.diligenceState = state;
                        vm.registerEntryDiligenceState = $filter('translate')('global.reg.diligenceState.' + vm.registerEntryDiligence.diligenceState);

                        $rootScope.$broadcast('registerEntryDiligenceStateUpdated');
                        
                    	var diligence = ((data && data.data)?JSOG.decode(data.data):{});

                        if (diligence && diligence.registerEntryDiligenceAudits) {
                        	vm.registerEntryDiligence.registerEntryDiligenceAudits = diligence.registerEntryDiligenceAudits;
                        	
                        	$rootScope.$broadcast('registerEntryDiligenceAuditUpdated', { content: vm.registerEntryDiligence.registerEntryDiligenceAudits });
                        }

                        if(modal) {
                            modal.close();
                        }

                        if(state == 'REJECT') {
                            $state.go('annexa.reg.input.diligences');
                        }

                        if(state == 'ACCEPT') {
                            vm.taskBox.permissions = getEditPermissions('tasks');
                        }
                    }).catch(function (error) {
                        $rootScope.loading(false);
                        console.error(error);
                        if(modal) {
                            modal.alerts.push({ msg: ErrorFactory.getErrorMessage('registerDiligence', 'updateState', error) });
                        }
                });
            }

            vm.acceptDiligence = function() {
                updateDiligenceState('ACCEPT');
            }

            vm.rejectDiligence = function() {
                var rejectReasonModal = {
                    title: 'global.literals.rejectReason',
                    size: '',
                    fieldsDefinition: [
                        { type: 'field', id: 'reason', fieldType: 'textarea', colClass: 'col-sm-12', required: true, label: 'global.literals.reason', maxLength: 1024 },
                    ],
                    alerts: [],
                    submit: function() {
                    }
                }

                var submitRejectReasonModal = function() {
                    this.form.$setSubmitted();

                    if(this.form.$valid) {
                        updateDiligenceState(
                            'REJECT',
                            '#' + Language.getActiveColumn() + '#' + this.model.reason + "@@" + $filter('translate')('global.literals.registerEntryDiligenceComment', { profile: vm.registerEntryDiligence.diligenceProfile[Language.getActiveColumn()] }),
                            rejectReasonModal
                        );
                    }
                }

                AnnexaFormlyFactory.showAnnexaFormModal('modalRejectReasonModal', rejectReasonModal, submitRejectReasonModal);
            }

            vm.finishDiligence = function () {
                updateDiligenceState('FINISHED');
            }

            vm.readDiligence = function() {
                updateDiligenceState('READ');
            }

            vm.sendToDiligence = function () {
                RegFactory.sendTodiligenceModalOpen(vm.registerEntryDiligence, vm.registerEntry, 'annexa.reg.input.diligences');
            }

            vm.auditDiligence = function () {
                if (vm.diligenceId) {
                    window.open($state.href('annexa.admin.audit_diligence', {"objectId": vm.diligenceId }), '_blank');
                }
            };

            //endregion

            //region Dossier Methods


            var getAllowedFamilyProcedures = function(registerEntryClassification, profile, initDossierModal) {
                var procedureHaveStartProfile = function (profile, procedure) {
                    return $linq(procedure.procedureStartProfiles).count("x => x.profile.id == " + profile.id) > 0;
                }

                var getProceduresByProfile = function(profile, procedures) {
                    var retProcedures = [];

                    _.forEach(procedures, function(item) {
                        if(procedureHaveStartProfile(profile, item)) {
                            retProcedures.push(item);
                        }
                    });

                    return retProcedures;
                }

                var addParentFamily = function (parent, listFamilyProcedures) {
                    if($linq(listFamilyProcedures).count("x => x.id == " + parent.id) == 0) {
                        if(parent.parent) {
                            listFamilyProcedures = addParentFamily(parent.parent, listFamilyProcedures);
                        }

                        listFamilyProcedures.push(parent);
                    }

                    return listFamilyProcedures;
                }

                var familyProcedures = RegFactory.familyProcedures;
                var retFamilyProcedures = [];

                if(registerEntryClassification && registerEntryClassification.procedures && registerEntryClassification.procedures.length > 0) {
                    familyProcedures = [];

                    _.forEach(registerEntryClassification.procedures, function(item) {
                        if(item.family && $linq(familyProcedures).count("x => x.id == " + item.family.id) == 0) {
                            var family = $linq(RegFactory.familyProcedures).singleOrDefault(undefined, "x => x.id == " + item.family.id);

                            if(family) {
                                familyProcedures.push(family);
                            }
                        }
                    });
                }

                if(familyProcedures && familyProcedures.length > 0) {
                    _.forEach(familyProcedures, function (item) {
                        var procedures = getProceduresByProfile(profile, item.procedures);

                        if(procedures && procedures.length > 0) {
                            if($linq(retFamilyProcedures).count("x => x.id == " + item.id) == 0) {
                                if (item.parent) {
                                    retFamilyProcedures = addParentFamily(item.parent, retFamilyProcedures);
                                }

                                retFamilyProcedures.push(item);
                            }
                        }
                    })
                }
				if(retFamilyProcedures && retFamilyProcedures.length > 0){
					 retFamilyProcedures = new SortedArray(retFamilyProcedures, Language.getActiveColumn()).sort();
				}
                return retFamilyProcedures;
            }
            
            var getAllFamiliesFromParent = function (familyTree, parentId) {
            	var lstFamilyId = [];
            	
            	if (familyTree && parentId){
            		if (familyTree[parentId]) {
	            		_.forEach(familyTree[parentId], function(familyChild) {
	            			var listAux = getAllFamiliesFromParent(familyTree, familyChild.id);
	            			lstFamilyId = lstFamilyId.concat(listAux);
	            		});
            		}
            		if (!_.contains(lstFamilyId, parentId)) {
            			lstFamilyId.push(parentId);
            		}
            	}
            	
            	return lstFamilyId;
            }

            // iniciar un expediente
            vm.initDossier = function () {
            	RegFactory.getFamilyProcedures().then(function(data) {
	                var initDossierModal = {
	                    title: 'global.literals.initExp',
	                    size: '',
	                    icon: 'fa fa-file-text-o',
	                    fieldsDefinition: [
	                        { type: 'field', id: 'familyProcedure', fieldType: 'select-tree', data: CommonService.getTreeData(getAllowedFamilyProcedures(vm.registerEntry.entryClassification, vm.registerEntryDiligence.diligenceProfile, initDossierModal), Language.getActiveColumn()), required: false, label: 'global.literals.family', model: {} },
	                        { type: 'field', id: 'procedure', fieldType: 'select', data: [], required: true, label: 'global.literals.procedure',
	                            watchers: {
	                                type: '$watchCollection',
	                                expression: 'model.familyProcedure',
	                                listener: function(field, _new) {
                                        var procedureAll = [];
                                        var procHaveStartProfile = function (profile, procedure) {
                                            return $linq(procedure.procedureStartProfiles).count("x => x.profile.id == " + profile.id) > 0;
                                        }
	                                    if(_new && _new.$selected && _new.$selected.id) {
	                                        var lstFamilyId = [];
	                                        var familyTree = angular.element('#modalInitDossier');
	                                        
	                                        if (familyTree && familyTree.scope() && familyTree.scope().modalObj && familyTree.scope().modalObj.fieldsDefinition 
	                                        		&& familyTree.scope().modalObj.fieldsDefinition[0] && familyTree.scope().modalObj.fieldsDefinition[0].data) {
	                                        	lstFamilyId = getAllFamiliesFromParent(familyTree.scope().modalObj.fieldsDefinition[0].data,_new.$selected.id);
	                                        } else {
	                                        	lstFamilyId.push(_new.$selected.id);
	                                        }
	
	                                        if( (vm.registerEntry.entryClassification && (!vm.registerEntry.entryClassification.procedures || vm.registerEntry.entryClassification.procedures.length == 0)) || !vm.registerEntry.entryClassification ){
	                                            procedureAll = $linq(GlobalDataFactory.procedures).where(function(x){
	                                            	if (x.active && x.family && x.family.id && _.contains(lstFamilyId, x.family.id)) {
	                                            		return true;
	                                            	} else {
	                                            		return false;
	                                            	}
	                                            }).toArray();
	                                        }
	
	                                        else if( vm.registerEntry.entryClassification && vm.registerEntry.entryClassification.procedures ){
	                                            procedureAll = $linq(vm.registerEntry.entryClassification.procedures).where(function(x){
	                                            	if (x.active && x.family && x.family.id && _.contains(lstFamilyId, x.family.id)) {
	                                            		return true;
	                                            	} else {
	                                            		return false;
	                                            	}
	                                            }).toArray();
	                                        }
	
	                                        if(procedureAll && procedureAll.length > 0){
	                                        	var procedureAllComplete = [];
	                                        	_.forEach(procedureAll, function(proc){
	                                        		if(proc.procedureStartProfiles && proc.procedureStartProfiles.length > 0){
		                                        		if(procHaveStartProfile(vm.registerEntryDiligence.diligenceProfile, proc)){
		                                        			procedureAllComplete.push(proc);
		                                        		}
	                                        		}else{
	                                        			var proceduresAux = $linq(RegFactory.familyProcedures).where(function(x){if (x.id && _.contains(lstFamilyId, x.id)) {return true;} else {return false;}}).select("x => x.procedures").toArray();
	                                                    if(proceduresAux && proceduresAux.length > 0){
	                                                        var proceduresAllAux = [];
		                                       				_.forEach(proceduresAux, function(procAux){
		                                       					if(procAux && procAux.length > 0){
		                                       				    	proceduresAllAux = $linq(proceduresAllAux).concat(procAux).toArray();
		                                       				    }
		                                       				 });
		                                       				 if(proceduresAllAux && proceduresAllAux.length > 0){
		                                       					 var procOk = $linq(proceduresAllAux).firstOrDefault(undefined, "x => x.id == "+proc.id);
		                                       					 if(procOk){
		                                       						if(procHaveStartProfile(vm.registerEntryDiligence.diligenceProfile, procOk)){
		         	                                        			procedureAllComplete.push(angular.copy(procOk));
		         	                                        		}
		                                       					 }
		                                       				 }
		                                       			 }
	                                        		}
	                                        	});
	                                        	
	                                        	field.templateOptions.options = procedureAllComplete;
	                                        }else{
	                                        	 field.templateOptions.options = [];
	                                        }
	                                    } else {
	                                    	if( (vm.registerEntry.entryClassification && (!vm.registerEntry.entryClassification.procedures || vm.registerEntry.entryClassification.procedures.length == 0)) || !vm.registerEntry.entryClassification ){
	                                            procedureAll = $linq(GlobalDataFactory.procedures).where("x => x.active == true").toArray();
	                                        }else if( vm.registerEntry.entryClassification && vm.registerEntry.entryClassification.procedures ){
	                                            procedureAll = $linq(vm.registerEntry.entryClassification.procedures).where("x => x.active == true").toArray();
	                                        }
	                                    	if(procedureAll && procedureAll.length > 0){
	                                        	var procedureAllComplete = [];
	                                        	_.forEach(procedureAll, function(proc){
	                                        		if(proc.procedureStartProfiles && proc.procedureStartProfiles.length > 0){
		                                        		if(procHaveStartProfile(vm.registerEntryDiligence.diligenceProfile, proc)){
		                                        			procedureAllComplete.push(proc);
		                                        		}
	                                        		}else{
	                                        			var proceduresAux = $linq(RegFactory.familyProcedures).select("x => x.procedures").toArray();
	                                                    if(proceduresAux && proceduresAux.length > 0){
	                                                        var proceduresAllAux = [];        
		                                       				_.forEach(proceduresAux, function(procAux){
		                                       					if(procAux && procAux.length > 0){
		                                       				    	proceduresAllAux = $linq(proceduresAllAux).concat(procAux).toArray();
		                                       				    }
		                                       				 });
		                                       				 if(proceduresAllAux && proceduresAllAux.length > 0){
		                                       					 var procOk = $linq(proceduresAllAux).firstOrDefault(undefined, "x => x.id == "+proc.id);
		                                       					 if(procOk){
		                                       						if(procHaveStartProfile(vm.registerEntryDiligence.diligenceProfile, procOk)){
		         	                                        			procedureAllComplete.push(angular.copy(procOk));
		         	                                        		}	                                       						 
		                                       					 }
		                                       				 }
		                                       			 }
	                                        		}
	                                        	});
	                                        	
	                                        	procedureAllComplete = $linq(procedureAllComplete).orderBy("x => x.language1",linq.caseSensitiveComparer).toArray();
	                                        	field.templateOptions.options = procedureAllComplete;
	                                        } else {
	                                        	field.templateOptions.options = [];
	                                        }
	                                    }
	                                }
	                            }}
	
	                    ],
	                    alerts: [],
	                    submitModal: function () {
	                    }
	                }
	
	                var submitInitDossier = function () {
	                    this.form.$setSubmitted();
	                    var moreAddressesOnThirds = $linq(vm.registerEntry.thirds).where("x => x.third.addresses.length > 1").toArray();
	                    if(moreAddressesOnThirds.length > 0){
	                    	_.forEach(moreAddressesOnThirds, function(thirds){
	                    		if(thirds.thirdAddress){
	                    			_.forEach(thirds.third.addresses, function(address){
		                    			if(address.id === thirds.thirdAddress.id){
		                    				address.default = true;
		                    				address.defaultByType = true;
		                    			}else if(address.default == true){
		                    				address.default = false;
		                    				address.defaultByType = false;
		                    			}
		                    		});
	                    		}
	                    	});
	                    }
	                    if(this.form.$valid) {
	                        initDossierModal.close();
	                        $state.go('annexa.tram.newdossier', {
	                            procedure: this.model.procedure,
	                            register: vm.registerEntry,
	                            diligence: vm.registerEntryDiligence
	                        });
	                    }
	                }
	
	                AnnexaFormlyFactory.showAnnexaFormModal('modalInitDossier', initDossierModal, submitInitDossier);
            	}).catch(function(error) {
            		DialogsFactory.error('global.reg.literals.initExpError');
                });
    
            }

            // adjuntar un expediente
            vm.attachDossier = function () {
                if((!vm.thirdBox.content || vm.thirdBox.content.length == 0) && (!vm.documentBox.content || vm.documentBox.content.length == 0)) {
                    DialogsFactory.error('global.reg.literals.attachExpErrorLength');
                } else {
                	var openModalAttachDossierModal = function(settlements){
                		var attachDossierReceivers = function () {
                            var receivers = [];

                            _.forEach(vm.thirdBox.content, function(item) {
                                receivers.push({
                                    id: item.id,
                                    allName: '<span style="display:inline">' + ThirdFactory.getThirdCompleteName(item.third) + ' <span class="label label-xxs">' + ThirdFactory.getRelatedThirdType(item) + '</span></span>'
                                });
                            });

                            return receivers;
                        }

                        var attachDossierDossiers = function () {
                            var dossiers = [];

                            _.forEach(vm.dossierBox.content, function (item) {
                                if(!item.closed) {
                                    var dossierTransactions = [];

                                    _.forEach(item.dossierTransactions, function(dt) {
                                        dossierTransactions.push({
                                            id: dt.id,
                                            language1: dt.language1,
                                            language2: dt.language2,
                                            language3: dt.language3,
                                            actual: dt.actual
                                        });
                                    });

                                    dossiers.push({
                                        id: item.id,
                                        allSubject: item.dossierNumber + (item.subject ? ' ' + item.subject : ''),
                                        dossierTransactions: dossierTransactions
                                    });
                                }
                            });

                            return dossiers;
                        }

                        var attachDossierDossiersAdvancedSearch = function (e) {
                            e.preventDefault();
                            var advacendSearchModal = AnnexaBoxDossierFactory.getAdvancedSearchModal(vm.content);
                            advacendSearchModal.tableDefinition.callToAdd = { closed: false };
                            advacendSearchModal.multiple = false;

                            AnnexaFormlyFactory.showAnnexaAdvancedSearchModal('modalASDossiersAttach', advacendSearchModal);
                        }
                        var documentToAttach = angular.copy(vm.documentBox.content);
                        if(documentToAttach && documentToAttach.length > 0){
                        	documentToAttach = $linq(documentToAttach).select("x => x.document").toArray();
                        }
                        var settlementsToAttach = [];
    					if(settlements && settlements.length > 0){
    						_.forEach(settlements, function(set){
    							set.name = set.settlementNumber+" "+set.subject;
    						});
    						settlementsToAttach = settlements;
    					}
                        var attachDossierModal = {
                            title: 'global.reg.literals.attachExp',
                            size: '',
                            icon: 'fa fa-paperclip',
                            fieldsDefinition: [
                            ],
                            alerts: [],
                            submitModal: function () {
                            }
                        }
                        attachDossierModal.fieldsDefinition.push({ type: 'field', id: 'receivers', fieldType: 'select_multiple_html', colClass: 'daughter-label-strong', labelProp: 'allName', data: attachDossierReceivers(), label: 'global.literals.remitents' });
                        attachDossierModal.fieldsDefinition.push({ type: 'field', id: 'documents', fieldType: 'component', componentType: 'annexa-select-documents',
                            data: {
                                title: 'global.literals.documents',
                                documents: documentToAttach,
    							documentsIdSelected: (($rootScope.app && $rootScope.app.configuration && $rootScope.app.configuration.diligence_attach_to_dossier_documents_all_default && $rootScope.app.configuration.diligence_attach_to_dossier_documents_all_default.value && documentToAttach && documentToAttach.length > 0)? $linq(documentToAttach).select("x => x.id").toArray() : undefined)	
                            }
                        });
                        if($rootScope && $rootScope.app && $rootScope.app.configuration && $rootScope.app.configuration.settlement_properties_active && $rootScope.app.configuration.settlement_properties_active.active){
                    		attachDossierModal.fieldsDefinition.push({ type: 'field', id: 'settlements', fieldType: 'component', componentType: 'annexa-select-documents',
                                data: {
                                    title: 'global.taxBlock.settlements',
                                    documents: settlementsToAttach,
    								documentsIdSelected: (($rootScope.app && $rootScope.app.configuration && $rootScope.app.configuration.diligence_attach_to_dossier_documents_all_default && $rootScope.app.configuration.diligence_attach_to_dossier_documents_all_default.value && settlementsToAttach && settlementsToAttach.length > 0)? $linq(settlementsToAttach).select("x => x.id").toArray() : undefined)	
                                }
                            });
                        }
    	        		attachDossierModal.fieldsDefinition.push({ type: 'field', id: 'dossier', fieldType: 'select_advanced_search', colClass: 'daughter-label-strong', labelProp: 'allSubject', data: attachDossierDossiers(), label: 'global.literals.relatedDossiers', advancedSearch: attachDossierDossiersAdvancedSearch, required: true,
                            controller: ['$scope', function($scope) {
                                $scope.$on('annexaAdvancedSearchModalAdd', function (event, args) {
                                    if(args.id == 'modalASDossiersAttach') {
                                        if(args.selected && args.selected.length > 0 && $linq($scope.to.options).count("x => x.id == " + args.selected[0].id) == 0) {
                                        	var ids = $linq(args.selected).select("x=> x.id").toArray();
                                        	RegFactory.getDossierTransactionByDossierId(ids).then(function(data) {
                                                if(data && data.length > 0 && data[0].id == args.selected[0].id) {
                                                	$scope.to.options.push({
                                                        id: args.selected[0].id,
                                                        allSubject: args.selected[0].dossierNumber + (args.selected[0].subject ? ' ' + args.selected[0].subject : ''),
                                                        dossierTransactions: data[0].dossierTransactions
                                                    });
                                                }
                                            	$scope.model.dossier = args.selected[0].id;
                                            	args.modal.close();
                                            }).catch(function (error) {
                                                console.error(error);
                                            	$scope.model.dossier = args.selected[0].id;
                                            	args.modal.close();
                                            });
                                        }else{
                                        	$scope.model.dossier = args.selected[0].id;
                                        	args.modal.close();
                                        }
                                    }
                                });
                            }],
                            hideExpression: function($viewValue, $modelValue, scope) {
                                if(scope.model && scope.model.otherDossier) {
                                    return true;
                                } else {
                                    return false;
                                }
                            }
                        });
                        attachDossierModal.fieldsDefinition.push({ type: 'field', id: 'dossierTransaction', fieldType: 'select', colClass: 'daughter-label-strong', data: [], label: 'global.tram.literals.transactions', required: true,
                            hideExpression: function($viewValue, $modelValue, scope) {
                                if(scope.model && scope.model.dossier) {
                                    var indexFieldDossierTransaction = $linq(scope.fields).indexOf("x => x.key == 'dossierTransaction'");

                                    if(indexFieldDossierTransaction != -1) {
                                        var fieldDossier = $linq(scope.fields).singleOrDefault(undefined, "x => x.key == 'dossier'");

                                        if(fieldDossier) {
                                            var dossier = $linq(fieldDossier.templateOptions.options).singleOrDefault(undefined, "x => x.id ==" + scope.model.dossier);

                                            if(dossier) {
                                                scope.fields[indexFieldDossierTransaction].templateOptions.options = $linq(dossier.dossierTransactions).where("x => x.actual").toArray();
                                            }
                                        }
                                    }

                                    return false;
                                } else {
                                    scope.model.dossierTransactions = [];
                                    return true;
                                }
                            }
                        });
                        attachDossierModal.fieldsDefinition.push({ type: 'field', id: 'otherDossier', fieldType: 'component', componentType: 'annexa-load-dossier-row',
                            data: {
                                colClass: ' col-sm-12',
                                labelClass: 'label-strong',
                                dossier: $scope.model,
                                templateOptions: {
                                    label: 'global.literals.searchOtherDossiers',
                                    required: false,
                                    type: 'text'
                                }
                            },   
                            hideExpression: function($viewValue, $modelValue, scope) {
                                if(scope.model && scope.model.dossier) {
                                    return true;
                                } else {
                                    return false;
                                }
                            }
                        });
                        attachDossierModal.fieldsDefinition.push({ type: 'field', id: 'otherDossierTransaction', fieldType: 'select', colClass: 'daughter-label-strong', data: [], label: 'global.tram.literals.transactions', required: true,
                            hideExpression: function($viewValue, $modelValue, scope) {
                                if(scope.model && scope.model.otherDossier) {
                                    var indexFieldDossierTransaction = $linq(scope.fields).indexOf("x => x.key == 'otherDossierTransaction'");

                                    if(indexFieldDossierTransaction != -1) {
                                        var fieldDossier = $linq(scope.fields).singleOrDefault(undefined, "x => x.key == 'otherDossier'");
                                        if(dossier) {
                                            scope.fields[indexFieldDossierTransaction].templateOptions.options = $linq(scope.model.otherDossier.dossierTransactions).where("x => x.actual").toArray();
                                        }
                                    
                                    }
                                    return false;
                                } else {
                                    scope.model.otherDossierTransaction = undefined;
                                    return true;
                                }
                            }
                        });
                        var submitAttachDossier = function() {
                            var self = this;
                            this.form.$setSubmitted();
                            var selectedDocumentsAux = angular.copy($linq(this.fieldsDefinition[1].data.documents).where("x => x.selected").toArray());
                            var selectedDocuments = [];
                            if(selectedDocumentsAux && selectedDocumentsAux.length > 0){
                            	_.forEach(selectedDocumentsAux, function(doc){
                            		selectedDocuments.push(doc.id);
                            	});
                            }
                            var selectedSettlements = [];
	                        if($rootScope && $rootScope.app && $rootScope.app.configuration && $rootScope.app.configuration.settlement_properties_active && $rootScope.app.configuration.settlement_properties_active.active){
			                    var selectedSettlementAux = angular.copy($linq(this.fieldsDefinition[2].data.documents).where("x => x.selected").toArray());
		                        if(selectedSettlementAux && selectedSettlementAux.length > 0){
		                        	_.forEach(selectedSettlementAux, function(doc){
										selectedSettlements.push(doc.id);
		                        	});
		                        }
	                        }
                            var dossierTransaction = undefined;
                            if(this.model.dossierTransaction) {
                            	dossierTransaction = this.model.dossierTransaction;
                            } else {
                            	dossierTransaction = this.model.otherDossierTransaction
                            }
                            if(this && this.model && !this.model.dossier && !this.model.otherDossier) {
                            	attachDossierModal.alerts.push({ msg: $filter('translate')('global.errors.dossierRequired') });
                            	return
                            }
    						if (this.form.$valid) { 
                                RegFactory.attachToDossier(vm.registerEntryDiligence, dossierTransaction, this.model.receivers, selectedDocuments, selectedSettlements) //
                                    .then(function(data) {
                                    	RegFactory.getRegisterEntryDiligenceAudit(vm.registerEntryDiligence.id).then(function(data2){
                                			if (data2) {
                                            	vm.registerEntryDiligence.registerEntryDiligenceAudits = data2;
                                            	
                                            	$rootScope.$broadcast('registerEntryDiligenceAuditUpdated', { content: vm.registerEntryDiligence.registerEntryDiligenceAudits });
                                            }
                                			
                                            if(data && data.id) {
    											var addDossier = true;
    											if(vm.dossierBox && vm.dossierBox.content && vm.dossierBox.content.length > 0){
    												var d = $linq(vm.dossierBox.content).firstOrDefault(undefined, "x => x.id == "+data.id);
    												if(d && d.id){
    													addDossier = false;
    												}
    											}
    											if(addDossier){
    												vm.dossierBox.content.push(data);
    											}
                                            }
                                            attachDossierModal.close();
                                            DialogsFactory.notify('global.literals.attachToExpOk');
            	                    	}).catch(function(error){
                                            console.error(error);
            	                    		DialogsFactory.error($filter('translate')('global.errors.unknownNew'));
            	                    	});
                                    }).catch(function (error) {
                                        console.error(error);
                                        attachDossierModal.alerts.push({ msg: ErrorFactory.getErrorMessage('registerDiligence', 'attachToExp', error.data) });
                                })
                            }
                        }

                        AnnexaFormlyFactory.showAnnexaFormModal('modalAttachDossier', attachDossierModal, submitAttachDossier);
                	}
                	$http({
                       	url: './api/reg/register_entry_settlement/register_entry_settlements/'+vm.registerEntry.id,
                       	method: 'GET'
					}).then(function (data, status, headers) {
						var settlements = JSOG.decode(data.data);
						var settlementsAux = [];
						if(settlements && settlements.length > 0){
							settlementsAux = $linq(settlements).select("x => x.settlement").toArray();
						}
						openModalAttachDossierModal(settlementsAux);
				    }).catch(function (error) {
				    	openModalAttachDossierModal([]);
                    });
                }
            }

            //endregion
        }],
        bindings: {
            isEdit: '=',
            redirectToList: '=',
            registerEntry: '=?',
            diligenceId: '@?',
            entryType: '@',
            preloadBoxes: '=?',
            isModal: '=',
            fromDossier: '=',
            tramClassification: '=?'
        }
    })
    .component('annexaBoxObjectRegEditHeader',{
        templateUrl: './components/reg/annexa-box-object-reg/annexa-box-object-reg-edit-header.html',
        require: {
            registerEntryComponent: '^^annexaBoxObjectReg'
        },
        controller:['$rootScope', '$filter', '$state', 'Language', 'RegFactory', function($rootScope, $filter, $state, Language, RegFactory) {
            var vm = this;

            vm.languageColumn = Language.getActiveColumn();
            
            RegFactory.getPreviousRegisterEntry(vm.registerEntry.id, vm.registerEntry.entryType);
			RegFactory.runCheckNextRegisterEntry(vm.registerEntry.id, vm.registerEntry.entryType);
            RegFactory.getNextRegisterEntry(vm.registerEntry.id, vm.registerEntry.entryType);
                        
            vm.prevRegEntryId = angular.copy(RegFactory.previousRegisterEntryId);
            vm.nextRegEntryId = angular.copy(RegFactory.nextRegisterEntryId);


            // region Pending

            vm.showPending = false;
            
            if($rootScope && $rootScope.app && $rootScope.app.configuration && $rootScope.app.configuration.reg_pending && $rootScope.app.configuration.reg_pending.value) {
            	vm.showPending = $rootScope.app.configuration.reg_pending.value;
            }
            
            vm.editPending = false;
            
            if(vm.registerEntry && vm.registerEntry.registerEntryOffice && vm.registerEntry.registerEntryOffice.registerEntryPending) {
            	vm.editPending = vm.registerEntry.registerEntryOffice.registerEntryPending;
            }
           

            vm.pendingOptions = [
                { id: true, name: $filter('translate')('global.literals.PENDING') },
                { id: false, name: $filter('translate')('global.literals.closed') }
            ]

            vm.printPending = function(value) {
                var template = '';

                if(value) {
                    template = '<span class="warn label rounded">' + $filter('translate')('global.literals.PENDING') + '</span>';
                } else {
                    template = '<span>' + $filter('translate')('global.literals.closed') + '</span>';
                }

                return template;
            }

            //endregion

            //region Managed

            vm.managedOptions = [
                { id: true, name: $filter('translate')('global.reg.literals.managed') },
                { id: false, name: $filter('translate')('global.reg.literals.noManaged') }
            ];

            vm.printManaged = function (value) {
                var template = '';

                template += value ? $filter('translate')('global.reg.literals.managed') : $filter('translate')('global.reg.literals.noManaged');

                return template;
            }

            vm.previousRegister = function () {
            	if($state && $state.current && ($state.current.name == 'annexa.reg.viewByNumberInput' || $state.current.name == 'annexa.reg.viewByNumberOutput') && vm.prevRegEntryId) {
            		RegFactory.previousRegisterEntryId = undefined;
            		RegFactory.nextRegisterEntryId = undefined;
                	if (vm.registerEntry.entryType == 'INPUT')
                		$state.go('annexa.reg.viewByNumberInput', { number: vm.prevRegEntryId.entryNumber });
                	else
                		$state.go('annexa.reg.viewByNumberOutput', { number: vm.prevRegEntryId.entryNumber });
            	} else if(vm.prevRegEntryId){
                	if (vm.registerEntry.entryType == 'INPUT')
                		$state.go('annexa.reg.input.entries.edit', { input: vm.prevRegEntryId.id });
                	else
                		$state.go('annexa.reg.output.entries.edit', { output: vm.prevRegEntryId.id });
            	}
            }
            
            vm.nextRegister = function() {
            	if($state && $state.current && ($state.current.name == 'annexa.reg.viewByNumberInput' || $state.current.name == 'annexa.reg.viewByNumberOutput') && vm.nextRegEntryId) {
            		RegFactory.previousRegisterEntryId = undefined;
            		RegFactory.nextRegisterEntryId = undefined;
                	if (vm.registerEntry.entryType == 'INPUT')
                    	$state.go('annexa.reg.viewByNumberInput', { number: vm.nextRegEntryId.entryNumber });
                	else
                		$state.go('annexa.reg.viewByNumberOutput', { number: vm.nextRegEntryId.entryNumber });
            	} else if(vm.nextRegEntryId){
                	if (vm.registerEntry.entryType == 'INPUT')
                    	$state.go('annexa.reg.input.entries.edit', { input: vm.nextRegEntryId.id });
                	else
                		$state.go('annexa.reg.output.entries.edit', { output: vm.nextRegEntryId.id });
            	}
            	
            }

            $rootScope.$on('prevRegisterEntry', function (event, args) {
            	vm.prevRegEntryId = args.prevRegisterEntry;
            });

            $rootScope.$on('nextRegisterEntry', function (event, args) {
            	vm.nextRegEntryId = args.nextRegisterEntry;
            });
            
            //endregion
        }],
        bindings: {
            registerEntry: '=?'
        }
    })